module.exports = __webpack_public_path__ + "static/media/larry1.ba7b9a95.mp3";